import React from "react";
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Card from 'react-bootstrap/Card'
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import './index.css'
import { ResetPasswordPut } from '../../ApiRequests'

import Cookies from 'universal-cookie'
import jwtDecode from 'jwt-decode'


const ResetPassword = (props) => {
    const navigate = useNavigate()
    const location = useLocation()
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    
    const [password, setPassword] = useState('')
    const [showConfirm, setShowConfirm] = useState(false)
    const [confirmPassword, setConfirmPassword] = useState('')
    const [error, setError] = useState('')

    const handleResetPassword = async () => {
        if (!token || token == '') {
            setError('Could not reset password, no token found. ')
        }

        const data = {password: password}
        const res = await ResetPasswordPut(token, data)
        console.log(res)
        if (res && 'data' in res) {
            navigate('/Login')
        } 
        

    }

    return (
        <div className="" style={{ paddingTop: '4rem', height: '100vh' }}>
            <div className="container d-flex flex-row align-items-center justify-content-center" style={{ maxWidth: '500px' }}>
                <Card style={{ width: '28rem' }}>
                    <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                        <Card.Title>Reset Password</Card.Title>
                        <div className="">
                            <hr></hr>
                            <Form.Control className='my-2' type='password' placeholder="password" value={password} onChange={(e) => setPassword(e.target.value)}></Form.Control>
                            {showConfirm && <Form.Control className='my-2' type='password' placeholder="confirm password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}></Form.Control>}
                            {!showConfirm && <Button className="w-100" onClick={() => setShowConfirm(true)}>Next</Button>}
                            {showConfirm && <Button className="w-100" disabled={password != confirmPassword} onClick={() => handleResetPassword()}>Reset Password</Button>}
                        </div>


                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}

export default ResetPassword;